import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import { LOCALES, PRODUCTION_DOMAIN, SEO } from '../../../constants';
import { BasicSeoElements } from '../BasicSEO';
import { useBabelSeo } from '../useBabelSeo';

type SearchResultsPageSEOProps = {
  term?: string;
};

export const SearchResultsPageSEO: FunctionComponent<
  SearchResultsPageSEOProps
> = ({ term = '' }: SearchResultsPageSEOProps) => {
  const resolveBabelSeo = useBabelSeo();
  const title = resolveBabelSeo('seo.search_results_page.title');
  const robots = {
    noArchive: true,
    noIndex: true,
    noFollow: false,
  };

  return (
    <>
      <BasicSeoElements
        title={title}
        imageUrl={SEO.SOCIAL_IMAGE_URL}
        robots={robots}
      />
      <Head>
        {Object.values(LOCALES).map((targetLocale) => (
          <link
            rel="alternate"
            hrefLang={targetLocale}
            href={`https://${PRODUCTION_DOMAIN}/${targetLocale}/search?term=${term}`}
            key={`/${targetLocale}/search?term=${term}`}
          />
        ))}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://${PRODUCTION_DOMAIN}/${LOCALES.EN}/search?term=${term}`}
        />
      </Head>
    </>
  );
};
